import React, {useMemo} from 'react';
import {connect} from "react-redux";
import {s3FeatureImagePath, THUMBNAIL_SIZES} from "../../../../../../misc/utils";
import FeatureName from "../../../../../visComponents/featureName";
import {SQFT_APPLIANCES_WITH_SUBMENU, SQFT_FEATURES} from "../../../../constants";
import {
  createApplianceOnTheWorkspace,
} from "../../../../helpers/featureHelper";
import {
  findGLBLink,
  getDepthFromDbFeature,
  getThirdPartyAR3DMetaData,
  getWidthFromDbFeature
} from "../../../../helpers/sqft3dArHelper";
import {setSelectedCountertop} from "../../../../../../actions/sqftMenuFunctions";

const SqftNavFeaturesRow = (props) => {
  const {feature, featureGroup, index, style, setActiveItemIndex} = props;
  const {isActiveItem, setSelectedCountertop} = props;
  const dbFeature = feature.part.dbFeature;

  const className = useMemo(() => isActiveItem ? 'lightbox-option-single lightbox-option-selected' : 'lightbox-option-single', [isActiveItem]);
  const imageUrl = useMemo(() => dbFeature.thumbnailUrl ? s3FeatureImagePath(dbFeature.thumbnailUrl, THUMBNAIL_SIZES.medium) : dbFeature.customThumbnail, [dbFeature]);

  const handleButtonClick = (e) => {
    void e
    setActiveItemIndex(index);
    if (SQFT_APPLIANCES_WITH_SUBMENU.includes(featureGroup.partId)) {
      const thirdPartyAR3DUrl = findGLBLink(dbFeature.thirdPartyAR3DUrls);// assume we have only one link to the model
      const thirdPartyAR3DMetaData = getThirdPartyAR3DMetaData(dbFeature, thirdPartyAR3DUrl);
      const width = getWidthFromDbFeature(dbFeature, thirdPartyAR3DMetaData);
      const depth = getDepthFromDbFeature(dbFeature, thirdPartyAR3DMetaData);

      const movableImage = createApplianceOnTheWorkspace(featureGroup.partId, dbFeature.id, {width, height: depth});
      void movableImage;
    } else if (featureGroup.partId === SQFT_FEATURES.countertop) {
      setSelectedCountertop(dbFeature.id);
    }
  };

  return (
    <div className={className} style={style} key={index}
         onClick={(e) => handleButtonClick(e)}>
      <div className="upper-image">
        {imageUrl ? <img src={imageUrl} className="accItem-image__block-img" alt=""/> : null}
      </div>
      <div className="upper-content">
        <div className="lightbox-title">
          <FeatureName feature={feature.part} maxLength={23}/>
        </div>
        <div className="lightbox-description-text-rectangular">

        </div>
      </div>
    </div>

  )
};

const mapStateToProps = (store) => {
  void store

  return {

  };
};

const mapDispatchToProps = {
  setSelectedCountertop
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavFeaturesRow);
